import React from "react";
import "../AboutCard/AboutCard.scss";
import ScrollAnimation from "react-animate-on-scroll";

class AboutCard extends React.Component {
  render() {
    return (
      <div className="AboutCard col-lg-4 mt-5 text-center">
        <ScrollAnimation
          animateIn="fadeInLeft"
          animateOnce={true}
          delay={this.props.delay}
        >
          <div className="cs_imgwrap">
            <img src={this.props.img} alt="about-icon" />
          </div>
          <p className="cs_title">{this.props.headline}</p>
          <p className="cs_text">{this.props.text}</p>
        </ScrollAnimation>
      </div>
    );
  }
}

export default AboutCard;
